import { useStyletron } from "baseui";
import React from "react";
import type { AppTemplateType } from "state-trees/src/AppTemplateType";
import type { ShopifyAppType } from "state-trees/src/assistant/AssistantMetadata";
import { appDisplayTypeForSummon } from "state-trees/src/assistant/summon";
import { CollapsibleMessage } from "../../assistant/chunks/ChatMessageChunkRenderer";
import { UserMessageBackgroundColor } from "../AssistantStyles";

export const AppSummonParagraph = (props: { children: React.ReactNode; style?: React.CSSProperties }) => {
  return (
    <p className="Assistant__summon-message-text" style={{ ...props.style }}>
      {props.children}
    </p>
  );
};

const DefaultAppSummonAvatar = (props: { emailHash: string }) => {
  return (
    <div className="Assistant__chat-avatar-container">
      <img src={`https://www.gravatar.com/avatar/${props.emailHash}?s=30&d=identicon&r=pg`} className="Assistant__chat-avatar" />
    </div>
  );
};

export const SummonTextChunk = (props: { content: string }) => {
  return (
    <div className="Assistant__chat-message-text-row">
      <div className="Assistant__chat-message-text-container">
        <AppSummonParagraph>{props.content}</AppSummonParagraph>
      </div>
    </div>
  );
};

export const SummonMessage = (props: { content?: string | null; children?: React.ReactNode; user?: string; avatar?: React.ReactNode }) => {
  const { children, content, avatar, user } = props;

  return (
    <article className="Assistant__chat-message">
      {user ? avatar ?? <DefaultAppSummonAvatar emailHash={user} /> : null}
      <div
        className="Assistant__chat-message-container message-container"
        style={{
          ...(user ? { backgroundColor: UserMessageBackgroundColor, padding: 0 } : {}),
        }}
      >
        {content && <SummonTextChunk content={content} />}
        {children}
      </div>
    </article>
  );
};

export const AppSummonMessage = (props: {
  prompt?: string | null;
  summary: string;
  appName?: string;
  appTemplateType?: AppTemplateType;
  shopifyAppType?: ShopifyAppType | null;
  $style?: React.CSSProperties;
}) => {
  const [_, $theme] = useStyletron();

  const shouldShowSummonMessageCard = (props.appTemplateType && props.appName) || props.summary;

  return (
    <div style={{ padding: $theme.sizing.scale300, ...props.$style }}>
      {props.prompt && (
        <AppSummonParagraph>
          <CollapsibleMessage content={props.prompt} noMarkdown />
        </AppSummonParagraph>
      )}

      {shouldShowSummonMessageCard && (
        <div className="Assistant__summon-message-card">
          {props.appTemplateType && props.appName && (
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", gap: $theme.sizing.scale500 }}>
              <div style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
                <AppSummonParagraph style={{ color: "rgba(0, 0, 0, 0.54)" }}>App name</AppSummonParagraph>
                <AppSummonParagraph>{props.appName}</AppSummonParagraph>
              </div>
              <div style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
                <AppSummonParagraph style={{ color: "rgba(0, 0, 0, 0.54)" }}>App type</AppSummonParagraph>
                <AppSummonParagraph>{appDisplayTypeForSummon(props.appTemplateType, props.shopifyAppType)}</AppSummonParagraph>
              </div>
            </div>
          )}

          {props.summary && (
            <div style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
              <AppSummonParagraph style={{ color: "rgba(0, 0, 0, 0.54)" }}>Prompt summary</AppSummonParagraph>
              <AppSummonParagraph>{props.summary}</AppSummonParagraph>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
